import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FaqModel, SearchsFaq } from 'src/app/shared/models/faq-model';
import { PaginationModel, PaginationModelNew } from 'src/app/shared/models/pagination';
import { AdminService } from 'src/app/shared/services/admin.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NotificationsService } from 'src/app/shared/services/notifications.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  faqsList: PaginationModelNew<FaqModel>;
  filteredFaqs: FaqModel[] = [];
  currentPage: number = 1;
  searchQuery: string = '';
  faq: number;
  question: string = '';
  filterActive: boolean = false;
  pageSize: number

  isFilterDropdownVisible: boolean = false;
  selectedFilterType: string = '';
  constructor(
    private _adminService: AdminService,
    private _notificationService: NotificationsService,
    private _router: Router,
    private _navigationService: NavigationService,
  ) { }

  ngOnInit(): void {
    this.getFaqs(1, '');
  }

  getFaqs(page: number, status: string): void {

    this._adminService.getBuyerFaq(page, status).subscribe((res) => {
    this.currentPage=page
      this.faqsList = res.data;
      this.filteredFaqs = this.faqsList.list;
      this.pageSize = this.faqsList.PageSize
    });
  }
  goBack(): void {
    this._navigationService.back();
  }


  search(): void {
    this.currentPage = 1;
    this.getFaqs(this.currentPage, this.searchQuery);
  }
  clearSearch(): void {
    this.searchQuery = '';
    this.currentPage = 1;
    this.getFaqs(this.currentPage, '');
  }


  toggleAnswer(item: FaqModel): void {
    this.filteredFaqs.forEach((faq) => {
      if (faq !== item) {
        faq['isVisible'] = false;
      }
    });
    item['isVisible'] = !item['isVisible'];
  }

  filterFaqs(): void {
    const query = this.searchQuery.toLowerCase();
    this.filteredFaqs = this.faqsList.list.filter(
      (faq) =>
        faq.Question.toLowerCase().includes(query) ||
        faq.Answer.toLowerCase().includes(query)
    );
  }



  toggleFilterDropdown(): void {
    this.isFilterDropdownVisible = !this.isFilterDropdownVisible;
  }


  onPageChange(page: number): void {

    this.getFaqs(page, this.searchQuery);

  }



}
